var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusstop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "29px",
    viewBox: "0 0 29 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "UI / MapElements / POIS / UKSH / Icons / bushaltestelle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-/-MapElements-/-POIS-/-UKSH-/-Icons-/-bushaltestelle",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Zeichen_224_-_Haltestelle,_StVO_2017",
    transform: "translate(0.000730, 0.000730)",
    fill: "#669C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g13365",
    transform: "translate(14.499635, 14.499635) scale(-1, 1) rotate(-180.000000) translate(-14.499635, -14.499635) "
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4995487,28.9992698 C6.49188611,28.9992698 0,22.5082459 0,14.4997211 C0,6.49188611 6.49188611,0 14.4995487,0 C22.5073837,0 28.9992698,6.49188611 28.9992698,14.4997211 C28.9992698,22.5082459 22.5073837,28.9992698 14.4995487,28.9992698 Z M14.4995487,25.1837897 C20.4006872,25.1837897 25.1837897,20.4006872 25.1837897,14.4997211 C25.1837897,8.59944482 20.4006872,3.81634233 14.4995487,3.81634233 C8.59940171,3.81634233 3.81548011,8.59944482 3.81548011,14.4997211 C3.81548011,20.4006872 8.59940171,25.1837897 14.4995487,25.1837897 Z",
    id: "path13369"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path13371",
    points: "8.8666888 6.6141484 8.8666888 22.3859836 11.2608483 22.3859836 11.2608483 15.6266811 17.7384216 15.6266811 17.7384216 22.3859836 20.1317188 22.3859836 20.1317188 6.6141484 17.7384216 6.6141484 17.7384216 13.5142509 11.2608483 13.5142509 11.2608483 6.6141484"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusstop);
export default __webpack_public_path__ + "static/media/busstop.62f079ce43cb47d92fa3cba5e982ff76.svg";
export { ForwardRef as ReactComponent };